/**
 * Encodes a URI component while preserving characters
 * like `/` etc. so the URL is human-readable.
 */
export function prettyEncodeComponent(component: string) {
  return component.replaceAll('&', '%26');
}
